module.exports = __webpack_public_path__ + "img/heart.e63e0774.svg";